/** Kullanıcı bazında seçilebilen arayüz tasarımları (sunucu: server/src/system/tercih.ts TASARIMLAR) */
export type DesignId = 'aurora' | 'obsidian' | 'ledger' | 'maya' | 'tasfirin';
export type Mode = 'acik' | 'koyu' | 'sistem';
export type Density = 'rahat' | 'normal' | 'sik';
/** sidebar: sol menü · rail: ikon rayı + açılır panel · topnav: üst menü */
export type Layout = 'sidebar' | 'rail' | 'topnav';

export interface DesignDef {
  id: DesignId;
  no: number;
  ad: string;
  ozet: string;
  layout: Layout;
  /** Yazı tipleri (yerel paketlerden, isteğe bağlı yüklenir) */
  fonts: () => Promise<unknown>[];
  /** Önizleme renkleri */
  renkler: string[];
  /** Kullanıcı "Sistem" seçtiğinde bile önerilen mod (Obsidian koyu doğmuştur) */
  dogalMod: 'acik' | 'koyu';
}

export const DESIGNS: DesignDef[] = [
  {
    id: 'aurora', no: 1, ad: 'Aurora', layout: 'sidebar', dogalMod: 'acik',
    ozet: 'Ferah, mor-indigo degrade vurgular, buzlu cam kartlar, yuvarlak hatlar.',
    renkler: ['#6366f1', '#a855f7', '#ec4899', '#f6f7fb'],
    fonts: () => [import('@fontsource-variable/plus-jakarta-sans'), import('@fontsource-variable/jetbrains-mono')],
  },
  {
    id: 'obsidian', no: 2, ad: 'Obsidian', layout: 'rail', dogalMod: 'koyu',
    ozet: 'Koyu ve keskin; zümrüt/camgöbeği vurgular, ikon rayı, komut paleti odaklı.',
    renkler: ['#09090b', '#10b981', '#22d3ee', '#27272a'],
    fonts: () => [import('@fontsource-variable/geist'), import('@fontsource-variable/geist-mono')],
  },
  {
    id: 'ledger', no: 3, ad: 'Ledger', layout: 'topnav', dogalMod: 'acik',
    ozet: 'Kurumsal; üst menü, yoğun tablolar, mavi vurgu. Finans paneli disiplini.',
    renkler: ['#ffffff', '#2563eb', '#0f172a', '#e2e8f0'],
    fonts: () => [import('@fontsource-variable/inter'), import('@fontsource-variable/jetbrains-mono')],
  },
  {
    id: 'maya', no: 4, ad: 'Ekşi Maya', layout: 'sidebar', dogalMod: 'acik',
    ozet: 'Zanaatkâr fırın: parşömen krem zemin, kabuk kahvesi, buğday altını; serif başlıklar, un serpintisi dokusu.',
    renkler: ['#f8f1e5', '#9a4d1b', '#d79a2b', '#3b2a1e'],
    fonts: () => [import('@fontsource-variable/dm-sans'), import('@fontsource-variable/fraunces'), import('@fontsource-variable/caveat'), import('@fontsource-variable/jetbrains-mono')],
  },
  {
    id: 'tasfirin', no: 5, ad: 'Taş Fırın', layout: 'sidebar', dogalMod: 'koyu',
    ozet: 'Odun ateşli taş fırın: kömür grisi taş, köz turuncusu ışıltı, kızgın kırmızı vurgu; karakterli başlıklar.',
    renkler: ['#15110e', '#f97316', '#dc2626', '#fbbf24'],
    fonts: () => [import('@fontsource-variable/bricolage-grotesque'), import('@fontsource-variable/caveat'), import('@fontsource-variable/jetbrains-mono')],
  },
];

export const designOf = (id: string | null | undefined): DesignDef => DESIGNS.find((d) => d.id === id) ?? DESIGNS[0];
